module.exports = __webpack_public_path__ + "img/selected2-min.9b622b18.png";